/*  NMRium Version: 0.33.0
    Notes: Any 2d file containing fid spectra should be regenerated with nmr-load-save package because the parser did not handle it correctly before this version

    *changes from version 3 to version 4:
      1- change the 2d data structure, in version 3 the 2D FT spectra have this structure which represents the real part that should be migrated to the new structure for 2D
         FT which contains `rr`, `ii`, `ri` and `ir` where `r` stands for the real part and `i` stands for the imaginary part
            Data
                {
                    data: {
                            z:Array<Array<Float64Array>>,
                            minX:number,
                            maxX:number,
                            minY:number,
                            maxY:number,
                            minZ:number,
                            maxZ:number,
                            noise:number
                        }
                }

                =>
               {
                    data: {
                            rr: {
                                    z:Array<Array<Float64Array>>,
                                    minX:number,
                                    maxX:number,
                                    minY:number,
                                    maxY:number,
                                    minZ:number,
                                    maxZ:number,
                                    noise:number
                                }
                            }
                }

            paths:
              - spectra > data

      2- skip the 2D FID spectra.
      3- change the filter zeroFilling object
          {
            value: number
          }
          ->
          {
            value: { nbPoints: number }
          }
      4- change the filters shiftX, shift2DX, shift2DY objects
          {
            value: number
          }
          ->
          {
            value: { shift: number }
          }
      5- jcampURL and jcampSpectrumIndex are splited into source and selector
        {
          spectra: {
            source: {
              jcampURL?: string
              jcampSpectrumIndex?: number
            }
          }
        }
        ->
        {
          source: {
            entries: [
              {
                baseURL?: string,
                relativePath: string
              }
            ]
          },
          spectra: [
            {
              sourceSelector: {
                jcamp: { index: number }
              }
            }
          ]
        }

      6- move 'name' object from the 'display' object to  the'info' object

         display:{
            name:"",
            ...etc
         }
          =>
         info: {
            name:"",
            ...etc
         }

    */
export default function migrateToVersion4(data) {
    if (data?.version === 4)
        return data;
    const { version, ...resData } = data;
    const spectra = [];
    const entries = {};
    for (const { source, ...oldSpectrum } of resData.spectra) {
        const newSpectrum = {};
        const { info = {}, display = {} } = oldSpectrum;
        if (info?.dimension === 2 && !source?.jcampURL) {
            if (info.isFt) {
                newSpectrum.data = { rr: oldSpectrum.data };
            }
            else {
                // skip pushing 2d fid spectrum to spectra array
                continue;
            }
        }
        if (source?.jcampURL) {
            const { jcampURL, jcampSpectrumIndex } = source;
            const matchResult = jcampURL.match(/(?<baseURL>^\w+:\/{2}\w+\/)(?<relativePath>.*)/);
            if (!entries[jcampURL]) {
                entries[jcampURL] = {
                    baseURL: matchResult?.groups.baseURL || '',
                    relativePath: matchResult?.groups.relativePath || jcampURL.replace(/^\.\//, ''),
                };
            }
            newSpectrum.sourceSelector = {
                files: [entries[jcampURL].relativePath],
            };
            if (jcampSpectrumIndex !== undefined) {
                newSpectrum.sourceSelector.jcamp = {
                    index: jcampSpectrumIndex,
                };
            }
        }
        // migrate zeroFilling and shift for 1d and 2d filters
        newSpectrum.filters = ensureFilterOptionsAreObjects(oldSpectrum.filters);
        // move 'name' object from 'display' object to the 'info' object
        const { name, ...otherDisplayProperties } = display;
        if (name) {
            newSpectrum.info = { ...info, name };
        }
        newSpectrum.display = otherDisplayProperties;
        spectra.push({ ...oldSpectrum, ...newSpectrum });
    }
    const migrated = {
        data: {
            ...resData,
            spectra,
        },
        version: 4,
    };
    const newSource = {
        entries: Object.values(entries),
    };
    if (newSource.entries.length)
        migrated.data.source = newSource;
    return migrated;
}
function ensureFilterOptionsAreObjects(filters = []) {
    const newFilters = [];
    for (const filter of filters) {
        const { name, value } = filter;
        switch (name) {
            case 'zeroFilling':
                newFilters.push({ ...filter, value: { nbPoints: value } });
                break;
            case 'shiftX':
            case 'shift2DX':
            case 'shift2DY':
                newFilters.push({ ...filter, value: { shift: value } });
                break;
            default:
                newFilters.push({ ...filter });
        }
    }
    return newFilters;
}
//# sourceMappingURL=migrateToVersion4.js.map